import type { IssueId } from '@atlassian/jira-software-board-common';
import { issueChildrenInFinalColumnRest } from '../../rest/issue/issue-children-in-final-column-rest';
import type { ServiceContext } from '../service-context';

export const issueChildrenInFinalColumnService = (ctx: ServiceContext, parentId: IssueId) =>
	issueChildrenInFinalColumnRest(parentId, ctx.boardId);
